import type { MomentInput } from 'moment';

export type TruentityDateInput = MomentInput;

export enum GeneralTimezone {
  EST = 'America/New_York'
}

export enum CustomTimezone {
  ACCOUNT_TIMEZONE = 'ACCOUNT_TIMEZONE',
  ADMIN_TIMEZONE = 'ADMIN_TIMEZONE'
}

export enum DayOfWeek {
  SUNDAY = 'SUNDAY',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY'
}
